<template>
  <lazy-div :load="doInit">
    <v-card>
      <!-- <v-card-title>
        <div class="headline">GL Account No. Details</div>
      </v-card-title> -->
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>View GL Account No. Details </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <message :messages="messages"></message>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.branch }}</v-subheader>
              <div class="queryValue">{{ glacctNoForm.branch }} - {{ glacctNoForm.brnDesc }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.glacctNo }}</v-subheader>
              <div class="queryValue">{{ glacctNoForm.glacctNo }}</div>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.fund }}</v-subheader>
              <div class="queryValue">{{ glacctNoForm.fund }} - {{ glacctNoForm.fundDesc }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.acctNoSfx }}</v-subheader>
              <div class="queryValue">{{ glacctNoForm.acctNoSfx }} - {{ glacctNoForm.acctNoSfxDesc }}</div>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12>
              <v-subheader class="queryLabel">{{ labels.description }}</v-subheader>
              <div class="queryValue">{{ glacctNoForm.description }}</div>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.acctType }}</v-subheader>
              <div class="queryValue">{{ acctType(glacctNoForm.acctType) }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.postType }}</v-subheader>
              <div class="queryValue">{{ postType(glacctNoForm.postType) }}</div>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.curr }}</v-subheader>
              <div class="queryValue">{{ glacctNoForm.curr }} - {{ glacctNoForm.currDesc }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.revalue }}</v-subheader>
              <div class="queryValue">{{ glacctNoForm.revalue ? 'Yes' : 'No' }}</div>
            </v-flex>
          </v-layout>
          <v-layout wrap v-if="glacctNoForm.revalue">
            <v-flex xs12>
              <v-subheader class="queryLabel">{{ labels.revalueAcctNo }}</v-subheader>
              <div class="queryValue">{{ glacctNoForm.revalueAcctNo }} {{ glacctNoForm.revalueFund }} {{ glacctNoForm.revalueAcctNoSfx }}</div>
            </v-flex>
          </v-layout>
          <V-layout wrap>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.permGst }}</v-subheader>
              <div class="queryValue">{{ glacctNoForm.permGst ? 'Yes' : 'No' }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.permDebtCashExp }}</v-subheader>
              <div class="queryValue">{{ glacctNoForm.permDebtCashExp ? 'Yes' : 'No' }}</div>
            </v-flex>
          </V-layout>
          <v-layout wrap>
            <v-flex xs12>
              <v-subheader class="queryLabel">{{ labels.parentAcct }}</v-subheader>
              <div class="queryValue">{{ glacctNoForm.parentAcctNo }} {{ glacctNoForm.parentFund }} {{ glacctNoForm.parentAcctNoSfx }}</div>
            </v-flex>
          </v-layout>
          <v-layout wrap v-if="glacctNoForm.yrClosed !== null && glacctNoForm.yrClosed !== 0">
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.yrClosed }}</v-subheader>
              <div class="queryValue">{{ glacctNoForm.yrClosed }}</div>
            </v-flex>
          </v-layout>
          <v-spacer class="mt-2"></v-spacer>
          <v-divider horizontal></v-divider>
          <v-layout>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
              <div class="queryValue">{{ glacctNoForm.createdBy }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
              <div class="queryValue">{{ glacctNoForm.createdDate | formatDate }}</div>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
              <div class="queryValue">{{ glacctNoForm.modifiedBy }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
              <div class="queryValue">{{ glacctNoForm.modifiedDate | formatDate }}</div>
            </v-flex>
          </v-layout>
          <!-- <v-layout>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{labels.modifiedProgId}}</v-subheader>
              <div class="queryValue">{{glacctNoForm.modifiedProgId}}</div>
            </v-flex>
          </v-layout> -->
          <v-layout wrap>
            <v-btn class="mr-2" color="error" @click="doCancel" :loading="submitting">
              <span>Cancel</span>
              <v-icon right dark>mdi-cancel</v-icon>
            </v-btn>
            <v-btn color="primary" dark class=" mr-2" @click="doParentAcctDialog(true)"> Add Parent Account </v-btn>
            <v-btn color="primary" dark class=" mr-2" @click="doParentAcctDialog(false)"> Remove Parent Account </v-btn>
            <v-btn color="primary" dark class=" mr-2" v-if="glacctNoForm.postType === 'S'" @click="srchChildDialog = true">
              List Child Accounts
            </v-btn>
          </v-layout>
        </v-container>
        <v-dialog width="800px" v-model="parentAcctDialog" persistent>
          <parent-acct :link="link" :parentAcct="parentAcct" @close="doClose($event)" :key="parentAcctDialog"></parent-acct>
        </v-dialog>
        <v-dialog width="800px" v-model="srchChildDialog" persistent>
          <srch-child @close="doClose" :key="srchChildDialog"></srch-child>
        </v-dialog>
      </v-card-text>
    </v-card>
  </lazy-div>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import { formatDisplayDate } from '@/utils/date'
import MessageMixin from '@/mixins/message'
import { postType, acctType } from '@/const/acct/glAcct'
import ParentAcct from '../ParentAcct/ParentAcct'
import SrchChild from '../ParentAcct/SrchChild'
export default {
  data() {
    return {
      labels: {
        branch: 'GL Account No. Branch',
        glacctNo: 'GL Account No.',
        fund: 'GL Account No. Fund',
        acctNoSfx: 'GL Account No. Suffix',
        description: 'Description',
        acctType: 'Account Type',
        postType: 'Post Type',
        curr: 'Currency',
        revalue: 'Revalue Indicator',
        revalueAcctNo: 'Revalue GL Account No.',
        permGst: 'Permit GST',
        permDebtCashExp: 'Permit Debtor/ Cash Expense',
        yrClosed: 'Year Closed',
        parentAcct: 'Parent Account',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date',
        modifiedProgId: 'Modified Program'
      },
      glacctNoForm: {
        branch: null,
        glacctNo: null,
        fund: null,
        acctNoSfx: null,
        description: null,
        acctType: null,
        postType: null,
        parentAcctNo: null,
        parentFund: null,
        parentAcctNoSfx: null,
        mixedCurr: null,
        curr: null,
        revalue: null,
        revalueAcctNo: null,
        revalueFund: null,
        revalueAcctNoSfx: null,
        yrClosed: 0,
        permGst: null,
        permDebtCashExp: null,
        createdProgId: null,
        modifiedProgId: null,
        brnDesc: null,
        fundDesc: null,
        acctNoSfxDesc: null,
        currDesc: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      helplistMenu: {},
      helplist: false,
      generalHelplist: false,
      helplistFieldKey1: null,
      helplistExpand: null,
      prevYrClosed: 0,
      submitting: false,
      parentAcctDialog: false,
      link: false,
      parentAcct: {
        parentAcctNo: null,
        parentFund: null,
        parentAcctNoSfx: null
      },
      srchChildDialog: false
    }
  },
  created() {
    if (!this.glacctNoId.branch && !this.glacctNoId.glacctNo) {
      const jsonData = JSON.parse(sessionStorage.getItem('glacctNo'))
      if (jsonData && jsonData.branch && jsonData.glacctNo) {
        this.$store.commit('GLACCTNO_COMMIT_KEY', jsonData)
      } else {
        this.$router.push({ name: 'glAcctNoList' })
      }
    }
  },
  methods: {
    async doInit() {
      await this.fetchData()
    },
    async fetchData() {
      const apiURI = this.menu.glacctNo
      if (apiURI) {
        try {
          const expand = this.glacctNoId
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.glacctNoForm.branch = data.glacctNo.branch
            if (data.branch) {
              this.glacctNoForm.brnDesc = data.branch.brnDesc
            }
            this.glacctNoForm.glacctNo = data.glacctNo.glacctNo
            this.glacctNoForm.fund = data.glacctNo.fund
            if (data.fund) {
              this.glacctNoForm.fundDesc = data.fund.fundDesc
            }
            this.glacctNoForm.acctNoSfx = data.glacctNo.acctNoSfx
            if (data.acctNoSfx) {
              this.glacctNoForm.acctNoSfxDesc = data.acctNoSfx.description
            }
            this.glacctNoForm.description = data.glacctNo.description
            this.glacctNoForm.acctType = data.glacctNo.acctType
            this.glacctNoForm.postType = data.glacctNo.postType
            this.glacctNoForm.curr = data.glacctNo.curr
            if (data.curr) {
              this.glacctNoForm.currDesc = data.curr.currDesc
            }
            this.glacctNoForm.revalue = data.glacctNo.revalue
            this.glacctNoForm.revalueAcctNo = data.glacctNo.revalueAcctNo
            this.glacctNoForm.revalueFund = data.glacctNo.revalueFund
            this.glacctNoForm.revalueAcctNoSfx = data.glacctNo.revalueAcctNoSfx
            this.glacctNoForm.permGst = data.glacctNo.permGst
            this.glacctNoForm.permDebtCashExp = data.glacctNo.permDebtCashExp
            this.glacctNoForm.parentAcctNo = data.glacctNo.parentAcctNo
            this.glacctNoForm.parentFund = data.glacctNo.parentFund
            this.glacctNoForm.parentAcctNoSfx = data.glacctNo.parentAcctNoSfx
            this.glacctNoForm.yrClosed = data.glacctNo.yrClosed
            this.prevYrClosed = data.glacctNo.yrClosed
            this.glacctNoForm.createdBy = data.createdBy
            this.glacctNoForm.createdDate = data.createdDate
            this.glacctNoForm.modifiedBy = data.modifiedBy
            this.glacctNoForm.modifiedDate = data.modifiedDate
            this.glacctNoForm.createdProgId = data.glacctNo.createdProgId
            this.glacctNoForm.modifiedProgId = data.glacctNo.modifiedProgId
            const commit = {
              branch: data.glacctNo.branch,
              glacctNo: data.glacctNo.glacctNo,
              fund: data.glacctNo.fund,
              acctNoSfx: data.glacctNo.acctNoSfx,
              curr: data.glacctNo.curr,
              postType: data.glacctNo.postType
            }
            this.$store.commit('GLACCTNO_COMMIT_KEY', commit)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    /**
     * true: link
     * false: unlink
     */
    async doParentAcctDialog(link) {
      if (this.glacctNoForm.yrClosed !== null && this.glacctNoForm.yrClosed !== 0) {
        this.$toast.error('Cannot update this record because Year Closed is not blank (10343)')
        return
      }
      if (link) {
        if (this.glacctNoForm.parentAcctNo || this.glacctNoForm.parentFund || this.glacctNoForm.parentAcctNoSfx) {
          this.$toast.error('Already linked to a Parent Account (30027)')
          return
        }
      } else {
        if (!this.glacctNoForm.parentAcctNo && !this.glacctNoForm.parentFund && !this.glacctNoForm.parentAcctNoSfx) {
          this.$toast.error('This GL Account is not linked to a Parent Account (30028)')
          return
        } else {
          try {
            this.submitting = true
            const apiURI = this.menu.checkGLLedger
            const expand = this.glacctNoId
            await this.$http.get(expandURI(apiURI, expand))
            this.submitting = false
          } catch (err) {
            this.submitting = false
            const { data } = err.response
            if (data) {
              this.notify(data)
            }
            return
          }
          this.parentAcct.parentAcctNo = this.glacctNoForm.parentAcctNo
          this.parentAcct.parentFund = this.glacctNoForm.parentFund
          this.parentAcct.parentAcctNoSfx = this.glacctNoForm.parentAcctNoSfx
        }
      }
      this.dialog = true
      this.parentAcctDialog = true
      this.link = link
    },
    doClose(reload) {
      this.parentAcctDialog = false
      this.srchChildDialog = false
      if (reload) {
        this.fetchData()
      }
    },
    acctType(value) {
      return acctType[value]
    },
    postType(value) {
      return postType[value]
    },
    doCancel() {
      this.$router.push({ name: 'glAcctNoList' })
    }
  },
  computed: {
    menu() {
      return this.$store.state.glAcctParam.menu
    },
    postTypeList() {
      let result = []
      Object.keys(postType).forEach((key) => {
        const status = postType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    acctTypeList() {
      let result = []
      Object.keys(acctType).forEach((key) => {
        const status = acctType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    maxYr() {
      return new Date().getFullYear()
    },
    glacctNoId() {
      return this.$store.state.glAcctParam.glAcctNo.glAcctNoId
    },
    newGLAcctNo() {
      return !(this.glacctNoId.branch || this.glacctNoId.glacctNo)
    }
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  components: {
    ParentAcct,
    SrchChild
  },
  mixins: [MessageMixin]
}
</script>

<style>
</style>
